import type { FaireProductEntity } from "../../entity_types/product";

export const p_d2kf8953b7: FaireProductEntity = {
  token: "p_d2kf8953b7",
  type: "product",
  name: "Gardening Minimal Retro Wall Art Print Vintage Home Decor",
  brandToken: "b_xegqzmw7gz",
  brandName: "Tumbleweed Design Studio",
  imageUrl:
    "https://cdn.faire.com/fastly/0daa2e890d64f16a0684b00392e8bd58190f6d0ee0f5b8dfaf76b578b900f799.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/fded2261072c4f365905f8027fc30e37a54d44fb254a286c07ff647640d0e664.jpeg",
    "https://cdn.faire.com/fastly/adb5f2f35448817ab11fa5bd34598d7c348228408946162daa58d0d899ba83d8.jpeg",
    "https://cdn.faire.com/fastly/6af27852d0e8774a22d6b1a1b09657b8464573d3595b1e001777dd4f9e0c6238.jpeg",
    "https://cdn.faire.com/fastly/0aa979cdba5a7cdd5b15afcd563b8492392f66e2d5bbe0477392e42232c8b356.jpeg",
  ],
  priceDollars: 14,
  description:
    "Add a touch of whimsical charm with a deeper meaning to your shop. This unframed art print uses a sketchy marker texture and imperfect details to bring a beautiful scene to life: a woman watering her garden. It's a versatile piece of wall art that speaks to growth and self-care, perfect for customers looking for art with a story.\n\nEach print is produced as a Museum-Quality Giclée on 300 gsm 100% Cotton Rag, a heavyweight, archival paper with a luxurious velvety texture. We use deep, rich archival inks lab-tested to remain fade-resistant for over 100 years. Every print includes a clean white border, providing a sophisticated, gallery-ready finish and making it easy to frame with or without a matte.  This print arrives hand-packed with a 22 pt protective chipboard backing in a crystal-clear sleeve.",
  tags: [],
  msrpDollars: 28,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-01T22:12:38.794Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
